<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'App',
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: 'Galleria',
    // all titles will be injected into this template
    titleTemplate: '%s | Galleria'
  },
}
</script>

<style lang="scss">
@import '../sass/blank';
</style>
